module.exports = __webpack_public_path__ + "img/org-default-banner-1.5803f55a.png";